import {
  Box,
  Highlight,
  type HighlightProps,
  theme,
} from "@kazaar-platform/design-system";
import { RiSparklingLine } from "@remixicon/react";

export const HighlightIA = ({
  children,
  variant = "primary",
}: HighlightProps) => {
  return (
    <Box w="fit-content">
      <Highlight variant={variant}>
        <Box display="inline" bgColor="bg.nobg" w="fit-content">
          <b style={{ paddingRight: theme.spacing["sp-xs3"] }}>{children}</b>

          <RiSparklingLine
            size="16px"
            style={{
              display: "inline-block",
              marginBottom: "2px",
            }}
          />
        </Box>
      </Highlight>
    </Box>
  );
};
